import { produce } from 'immer';
import { JSX, createContext, useState } from 'react';
import useMount from '../../../common/hooks/useMount';

import { merchantAccountsService } from '../services/merchant-accounts';
import { IAccountInfoContext } from './common';

export const AccountInfoContext = createContext(
  {} as {
    accountInfo: IAccountInfoContext;
    setAccountInfo: (accountInfo: IAccountInfoContext) => void;
  },
);

export function AccountInfoProvider(props: { children: JSX.Element }) {
  const [accountInfo, setAccountInfo] = useState({} as IAccountInfoContext);

  useMount(abortController => {
    (async () => {
      const result = await merchantAccountsService.getWhoAmI({
        signal: abortController?.signal,
      });

      if (!result.hasErrors) {
        setAccountInfo(
          produce(draft => {
            draft.id = result.data.id;
            draft.email = result.data.email;
            draft.firstName = result.data.firstName;
            draft.fullName = result.data.fullName;
            draft.lastName = result.data.lastName;
            draft.manufacturerId = result.data.manufacturerId;
            draft.manufacturerName = result.data.manufacturerName;
            draft.activeProductsNumber = result.data.activeProductsNumber;
            draft.avatarColor1 = result.data.avatarColor1;
            draft.avatarColor2 = result.data.avatarColor2;
            draft.avatarFontColor = result.data.avatarFontColor;
            draft.initials = result.data.initials;
            draft.notificationsCount = result.data.notificationsCount;
            draft.roleId = result.data.roleId;
            draft.isImpersonating = result.data.isImpersonating;
            draft.usesAnalytics = result.data.usesAnalytics;
          }),
        );
      }
    })();
  });

  return (
    <AccountInfoContext.Provider value={{ accountInfo, setAccountInfo }}>
      {props.children}
    </AccountInfoContext.Provider>
  );
}
